
import ArchiveCard from "../parts/extract/ArchiveCard";

import { Archive, Count, SearchRequest, } from "../library/CosmeWidgetAPIClient";
import { useContext, useEffect, useState } from "react";
import PageLoading from "../parts/PageLoading";
import ExtractFilterBar from "../parts/extract/ExtractFilterBar";
import { Text, makeStyles, mergeClasses, shorthands, tokens } from "@fluentui/react-components";
import { CWClientContext } from "../App";

const useStyles = makeStyles({
    main: {
        ...shorthands.margin("auto"),
        width: "80vw",
        marginTop: "40px",
        marginLeft: "18vw",
        height: 'calc(100vh - 110px)',
        overflowY: "scroll",
    },
    sidebar: {
        marginTop: "40px",
        height: 'calc(100vh - 150px)',
        width: "15vw",
        marginLeft: "1vw",
        minWidth: "100px",
        boxShadow: tokens.shadow8,
        position: "fixed",
    },
    cardArea: {
        columnCount: 5,
    },
});

/**
 * 
 * @returns 
 */
function ExtractPage() {
    const styles = useStyles();
    const [extracts, setExtracts] = useState<Archive[]>();
    const [counts, setCounts] = useState<Map<Archive, Count>>();
    // const cwClient: CosmeWidgetAPIClient = new CosmeWidgetAPIClient();
    const cwClient = useContext(CWClientContext);

    useEffect(() => {
        // (async () => {
        //     search({
        //         status: "DETECTED",
        //         limit: 100,
        //         offset: 0,
        //     });
        // })();
    }, []);

    const search = (request: SearchRequest) => {
        console.log("ExtractPage::search() called", request);
        setExtracts(undefined);

        (async () => {
            let res = await cwClient.searchArchives(request);
            let archiveIds: string[] = []
            res.map((a: Archive) => {
                archiveIds.push(a.id);
                return "";
            });
            console.log("search - archivers res = ", res);
            setExtracts(res);
            if (res.length !== 0) {
                console.log("setCounts undefined length = ", res.length);
                setCounts(undefined);
            } else {
                setCounts(new Map());
            }

            if (res.length > 0) {
                let cRes = await cwClient.getExtractCount(archiveIds);
                let counts: Map<Archive, Count> = new Map();
                res.forEach((ar: Archive, index: number) => {
                    cRes.forEach((cr: Count, index: number) => {
                        if (ar.id === cr.label) {
                            counts.set(ar, cr);
                        }
                    });
                });
                setCounts(counts);
            }
        })();


    }

    const cardArea = () => {
        if (extracts === undefined || counts === undefined) {
            console.log("extracts", extracts);
            console.log("counts", counts);
            return (
                <PageLoading
                    message="抽出結果を読み込み中"
                />
            );
        } else if (extracts.length === 0) {
            return (
                <Text>抽出結果がありません</Text>
            );
        } else {
            return (
                <>
                    <div className={styles.cardArea}>
                        {extracts.map((item: Archive) => {
                            return (
                                <ArchiveCard
                                    key={item.id}
                                    archive={item}
                                    count={counts.get(item)}
                                />
                            );
                        })}
                    </div>
                </>
            );
        }
    }

    return (
        <>
            <div className={styles.sidebar} >
                <ExtractFilterBar
                    searchCallback={search}
                    defaultSearch={
                        {
                            status: undefined,
                            startDate: undefined,
                            biteki: undefined,
                            maquia: undefined,
                            ivoce: undefined,
                            media: undefined,
                        }
                    }
                ></ExtractFilterBar>
            </div >
            <div className={mergeClasses(styles.main,)}>
                {cardArea()}
            </div>
        </>
    );
}
export default ExtractPage;